module.exports = __webpack_public_path__ + "media/images/sp/costumes/mv_shiromuku@2x-141582dfbee5df158afb2e2449f41f44.webp";